// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 
bootstrap responsive break points 
xs - 575px
sm - 767
md - 991
lg - 1200
// Large devices (desktops, less than 1200px)
*/
@media (max-width: 575.98px) {
  /* // Extra small devices (portrait phones, less than 576px) */

  :root {
    --font-xbig: 20px;
    --font-big: 20px;
    --font-medium: 10px;
    --font-xmedium: 9px;
    --font-small: 8px;
    --font-xSmall: 7px;
    --hide-on-sm: none;
  }
}

@media (max-width: 767.98px) and (min-width: 575.98px) {
  /* // Small devices (landscape phones, less than 768px) */
  :root {
    --font-xbig: 14px;
    --font-big: 12px;
    --font-medium: 11px;
    --font-xmedium: 10px;
    --font-small: 8px;
    --font-xSmall: 6px;
  }
}

@media (max-width: 991.98px) and (min-width: 767.98px) {
  :root {
    --font-xbig: 20px;
    --font-big: 20px;
    --font-medium: 13px;
    --font-xmedium: 12px;
    --font-small: 11px;
    --font-xSmall: 8px;
  }
}

@media (min-width: 991.98px) {
  :root {
    --font-xbig: 22px;
    --font-big: 18px;
    --font-medium: 14px;
    --font-xmedium: 12px;
    --font-small: 10px;
    --font-xSmall: 8px;
    --hide-on-sm: flex;
  }
}

div.sticky {
  position: sticky;
  top: 60px;
  min-width: 100px;
  min-height: 100px;
}

.hide-on-sm {
  display: var(--hide-on-sm) !important;
}

.font-xbig {
  font-size: var(--font-xbig) !important;
}
.font-big {
  font-size: var(--font-big) !important ;
}
.font-medium {
  font-size: var(--font-medium) !important;
}
.font-xmedium {
  font-size: var(--font-xmedium) !important;
}
.font-small {
  font-size: var(--font-small) !important;
}
.font-xSmall {
  font-size: var(--font-xSmal) !important;
}

#root {
  width: 100%;
  height: 100vh;
}
h3 {
  width: 100%;
  text-align: center;
}
.width-100 {
  width: 100% !important;
}
.width-95 {
  width: 95% !important;
}
.width-90 {
  width: 90% !important;
}
.width-80 {
  width: 80% !important;
}
.width-75 {
  width: 75% !important;
}
.width-70 {
  width: 70% !important;
}
.width-60 {
  width: 60% !important;
}
.width-50 {
  width: 50% !important;
}
.width-30 {
  width: 30% !important;
}
.width-40 {
  width: 40% !important;
}
.width-45 {
  width: 45% !important;
}
.width-33 {
  width: 33.33% !important;
}
.width-25 {
  width: 25% !important;
}
.width-20 {
  width: 20% !important;
}
.width-10 {
  width: 10% !important;
}
.width-30px {
  width: 30px !important;
}
.width-auto {
  width: auto !important;
}
.icon.XL {
  height: 50px;
}
.inline-hor {
  display: flex;
  justify-content: space-between;
}
header.large {
  font-size: 20px;
}
header.main {
  margin-top: 20px;
  padding-left: 10px !important;
}
header {
  font-weight: bold;
  margin: 10px 0 15px 0;
  width: 100%;
  text-align: center;
}
.center-hor {
  display: flex;
  align-items: center;
}
.align-item-end {
  display: flex;
  align-items: end;
}
.center-ver {
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
.center-ver-col {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.absolute-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.space-evenly {
  justify-content: space-evenly;
}
.space-around {
  justify-content: space-around;
}
.space-between {
  display: flex !important;
  justify-content: space-between;
}
.align-bottom {
  display: flex;
  align-items: end;
}
.bold-1 {
  font-weight: bold;
}
.bold-2 {
  font-weight: heavy;
}
.table-head-bg {
  /* background-color: rgba(102, 102, 102, 0.25) !important; */
}
.icon.mid {
  height: 18px;
}
.icon.xmid {
  height: 25px;
}
.icon.large {
  height: 30px;
}
.icon.xlarge {
  height: 60px;
}
.icon.color-lime {
  color: rgb(75, 211, 75) !important;
}
.icon {
  width: 100%;
  cursor: pointer;
}
.golden {
  color: var(--rf-brand-lite) !important;
}
.icon.white {
  color: white;
}
.icon.grey.white {
  color: white;
}
.icon.grey {
  color: #6a6a6a;
}
.float-right-top {
  position: absolute;
  top: 10px;
  right: 10px;
}
.float-right-bottom {
  position: absolute;
  right: 0px;
  bottom: 0;
}
.flex-start-ver {
  display: flex;
  align-items: flex-start;
}
.blur-overlay {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  filter: blur(3px);
  z-index: 8;
  background-color: rgba(255, 255, 255, 0.25);
}
.search.stretch {
  width: 100% !important;
}
.margin-0 {
  margin: 0px !important ;
}
.border-0 {
  border: none !important;
}
.border-rad-0 {
  border-radius: 0px !important;
}
.padding-LR-5 {
  padding: 0 5px 0 5px !important;
}
.padding-LR-15 {
  padding: 0 15px 0 15px !important;
}
.padding-10 {
  padding: 10px !important;
}
.padding-5 {
  padding: 5px !important;
}
.padding-0 {
  padding: 0 !important;
}
.padding-bottom-200 {
  padding-bottom: 200px !important;
}
.margin-top-5 {
  margin-top: 5px;
}
.margin-top-10 {
  margin-top: 10px !important;
}
.margin-top-50 {
  margin-top: 50px;
}
.margin-top-20 {
  margin-top: 20px !important;
}
.margin-top-100 {
  margin-top: 100px !important;
}
.margin-TB-10 {
  margin: 10px 0px !important;
}
.margin-10 {
  margin: 10px !important;
}
.margin-5 {
  margin: 5px !important;
}
.margin-LR-15 {
  margin: 0 15px 0 15px !important;
}
.float-bottom {
  position: absolute;
  left: 0;
  bottom: 10px;
}
.float-left {
  position: absolute;
  left: 10px;
}
.float-absolute-left {
  position: absolute;
  left: 0px;
}
.float-absolute-right {
  position: absolute;
  right: 0px;
}
.black-text {
  color: black !important;
}
.red-text {
  color: red !important;
}
.light-box-shadow {
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.25) !important;
}
.xlight-box-shadow {
  box-shadow: 0px 3px 8px rgba(142, 139, 139, 0.1) !important;
}
.overlaid-page.success > * {
  opacity: 0;
}
.overlaid-page {
  min-width: 200px !important;
  min-height: 100px !important;
}
.overlaid-page.active {
  transition: 300ms;
  opacity: 1;
  top: 75px;
  display: block;
}
.overlaid-page.add-user {
  width: var(--slide);
}
.overlaid-page.summary {
  min-height: 80vh !important;
}
.overlaid-page {
  top: -100%;
  opacity: 0;
  display: none;
  z-index: 0 !important;
  position: absolute;
  left: 3%;
  width: 94%;
  z-index: 99;
  min-height: 80vh;
  /* overflow-y: scroll; */
  background-color: white;
  transition: 300ms;
}
.float-bottom-right {
  position: absolute;
  bottom: 0;
  right: 0;
}
.float-bottom-left {
  position: absolute;
  bottom: 0;
  left: 0;
}
.gold-themed {
  background-color: var(--rf-brand-lite) !important;
  color: white !important;
}
.gold-themed-2 {
  color: var(--rf-brand-lite) !important;
  background-color: white !important;
}
.light-gold-themed {
  background-color: #daba75 !important;
  color: white !important;
}
.grey-themed {
  background-color: #6a6a6a !important;
  color: white !important;
}
.text-center {
  text-align: center;
}
.icon-small {
  height: 18px;
}
.float-right {
  position: absolute;
  right: 10px;
}
.float-left-bottom {
  position: absolute;
  left: 0;
  bottom: 0;
}
.relative {
  position: relative;
}

.small-list-card.user > img {
  width: auto !important;
  height: 40px !important;
  position: absolute;
  left: 5px;
}
.small-list-card.user:hover {
  background-color: #faeac7;
}
.small-list-card.user {
  position: relative;
  height: 40px !important;
  cursor: pointer;
}
.small-list-card.user > .icon {
  position: absolute;
  background-color: #d08484;
  right: 0px;
  top: 0px;
}
.small-list-card > .icon {
  height: 40px;
  padding: 10px 5px 10px 5px !important;
  margin-right: 10px !important;
  background-color: #d0b884;
  cursor: pointer;
}
.small-list-card {
  background-color: white;
  height: 30px;
  margin-bottom: 2px;
}

.display-none {
  display: none;
}
.product-type-nav {
  position: absolute;
  top: 0;
  width: 300px !important;
  overflow-y: hidden;
  z-index: 50;
}

.product-type-nav > div.toggleshower {
  background: #eaeaea;
  border-radius: 7px;
  height: 25px;
  cursor: pointer;
  font-size: var(--font-small);
  /* padding: 5px 10px; */
  color: #6a6a6a;
}
.product-type-nav > div.dropdown-content {
  display: none;
  /* height: 0px; */
  transition: 500ms;
}
.product-type-nav > div.dropdown-content.active {
  /* position: absolute; */
  background-color: white;
  padding: 10px 4px;
  /* display: block; */
  /* height: 400px; */
  display: flex;
  transition: 500ms;
}

.product-type-nav > div > div {
  cursor: pointer;
  min-width: 70px;
  padding: 0px 10px;
  height: 25px;
  border-radius: 6px;
  color: #494949;
  background-color: rgb(234, 234, 234);
  font-weight: bold;
  margin: 2px 0;
}
.product-type-nav > div:hover {
  /* background-color: rgb(255, 255, 255); */
}
.product-type-select-card.active {
  min-height: 100px;
  transition: 500ms;
  display: block;
}
.product-type-select-card {
  min-height: 0px;
  display: none;
  transition: 500ms;
}
.typetags {
  cursor: pointer;
  min-width: 70px;
  padding: 0px 10px;
  height: 25px;
  line-height: 25px;
  text-align: center;
  font-size: 11px;
  border-radius: 6px;
  color: #494949;
  background-color: rgb(234, 234, 234);
  font-weight: bold;
  margin: 4px 5px;
}
.margin-TB-10 {
  margin: 10px 0 10px 0;
}
.margin-TB-30 {
  margin: 30px 0 30px 0;
}
.flex-start-bottom {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.relative-bottom {
  position: absolute;
  bottom: 10px;
}
.bg-red {
  background-color: red !important;
}
.bg-grey {
  background-color: rgb(165, 165, 165) !important;
}
.bg-white {
  background-color: white !important;
}
.bg-lime {
  background-color: lime !important;
}
.float-top-right-most {
  position: absolute;
  right: 0px;
  top: 0px;
}
.float-top-right {
  position: absolute;
  right: 10px;
  top: 10px;
}
.float-right-most {
  position: absolute;
  right: 0;
  top: 0;
}
.stretch-height {
  display: flex !important;
  align-items: stretch !important;
}
.margin-left-10 {
  margin: auto 10px !important;
}
.table-row > .x-small {
  width: 40px !important;
}
.table-row > .small {
  min-width: 50px !important;
}
.justify-end {
  justify-content: flex-end !important;
}
.z-index-1 {
  z-index: 1 !important;
}
.z-index-2 {
  z-index: 2 !important;
}
.z-index-3 {
  z-index: 3 !important;
}
.xsmall-btn {
  height: 25px !important;
}
.small-btn {
  height: 30px !important;
}
.touchable {
  cursor: pointer;
}
.link-text {
  color: var(--rf-brand-lite);
}
.link-text:hover {
  color: #d0b884;
}
.hor-line {
  border-top: 1px solid #d8d8d8;
  width: 100%;
  margin: 5px 0px;
}
.justify-center {
  display: flex;
  justify-content: center;
}
.green-themed {
  background-color: #66b755;
  color: white !important;
}
.hidden {
  display: none !important;
}
.warning-text {
  color: red;
  font-size: var(--font-medium);
  font-weight: bold;
}
.padding-TL-4-5 {
  padding: 4px 5px;
}
.padding-TL-4-10 {
  padding: 4px 10px;
}
bold {
  font-weight: bold;
}
.warning-text {
  color: red;
}
.flex-grow {
  flex-grow: 1;
}
.display-flex {
  display: flex;
}
.opacity-75 {
  opacity: 0.75;
}
.profile-image-xlarge {
  width: 100px !important;
  height: 100px;
  border-radius: 50%;
}
.light-gold {
  background-color: #faeac7;
}
.light-red-bg {
  background-color: #ffa1a1 !important;
}
.red-bg {
  background-color: #b75555 !important;
}
.color-white {
  color: white !important;
}
.color-gold {
  color: #b79800 !important;
}
.margin-left-10 {
  margin-left: 10px;
}
.paddingLR-10 {
  padding-left: 30px;
  padding-right: 30px;
}
.marginRight-2 {
  margin-right: 1px;
}
.underline-1 {
  border-bottom: 1px solid grey;
}
.color-black {
  color: black !important;
}
.light-grey-bg {
  background-color: #c9c9c9 !important;
}
.color-red {
  color: red;
}
.height-stretch-container {
  display: flex;
  flex-wrap: wrap;
  align-content: stretch;
}
.text-left {
  text-align: left !important;
}
.text-right {
  text-align: right !important;
}
.line-bottom-dashed {
  border-bottom: 1px dashed black;
}
.margin-bottom-10 {
  margin: 0px 0px 10px 0px !important;
}
.border-radius-8 {
  border-radius: 8px !important;
}
.justify-start {
  justify-content: start !important;
}
.justify-end {
  justify-content: end !important;
}
.hover-underline:hover {
  text-decoration: underline;
}
.text-list > span {
  width: auto;
  padding: 5px 10px;
  font-weight: bold;
}
.border-none {
  border: none !important;
}
.light-gold-header {
  background: rgb(240, 212, 153);
  color: white;
}
.light-grey-header {
  background: rgb(244, 242, 242);
  color: #c59800;
}

.flex-end {
  justify-content: end;
}
.green-label-1{
  background-color:#44bf44;
  color: white;
  font-weight: bold;
  padding: 2px 10px;
  border-radius: 10px;
}
.margin-right-5 {
  margin-right: 5px !important;
}
.top-right {
  position: absolute;
  top: 10px;
  right: 10px;
}
.display-block {
  display: block;
}
.red-label-1{
  background-color: #dc4141;
  color: white;
  font-weight: bold;
  padding: 2px 10px;
  border-radius: 10px;
}`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;;;;;;;CAOC;AACD;EACE,8DAA8D;;EAE9D;IACE,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;EACpB;AACF;;AAEA;EACE,yDAAyD;EACzD;IACE,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;EACpB;AACF;;AAEA;EAEE,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,uCAAuC;AACzC;AACA;EACE,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,wBAAwB;EACxB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,4DAA4D;AAC9D;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,kCAAkC;AACpC;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,2CAA2C;AAC7C;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,+BAA+B;AACjC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,eAAe;AACjB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sDAAsD;AACxD;AACA;EACE,2DAA2D;AAC7D;AACA;EACE,UAAU;AACZ;AACA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,iBAAiB;EACjB,UAAU;EACV,SAAS;EACT,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,UAAU;EACV,UAAU;EACV,aAAa;EACb,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,wBAAwB;EACxB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;AACT;AACA;EACE,iDAAiD;EACjD,uBAAuB;AACzB;AACA;EACE,sCAAsC;EACtC,kCAAkC;AACpC;AACA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;AACA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;AACX;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,UAAU;EACV,QAAQ;AACV;AACA;EACE,YAAY;EACZ,qCAAqC;EACrC,6BAA6B;EAC7B,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,oCAAoC;EACpC,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,eAAe;EACf,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,oCAAoC;EACpC,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+CAA+C;AACjD;AACA;EACE,kCAAkC;AACpC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;AACR;AACA;EACE,wBAAwB;EACxB,+BAA+B;AACjC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,cAAc;AAChB;AACA;EACE,6BAA6B;EAC7B,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,UAAU;EACV,6BAA6B;EAC7B,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,+BAA+B;AACjC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,8BAA8B;EAC9B,YAAY;AACd;AACA;EACE,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,wBAAwB;EACxB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB","sourcesContent":["/* \nbootstrap responsive break points \nxs - 575px\nsm - 767\nmd - 991\nlg - 1200\n// Large devices (desktops, less than 1200px)\n*/\n@media (max-width: 575.98px) {\n  /* // Extra small devices (portrait phones, less than 576px) */\n\n  :root {\n    --font-xbig: 20px;\n    --font-big: 20px;\n    --font-medium: 10px;\n    --font-xmedium: 9px;\n    --font-small: 8px;\n    --font-xSmall: 7px;\n    --hide-on-sm: none;\n  }\n}\n\n@media (max-width: 767.98px) and (min-width: 575.98px) {\n  /* // Small devices (landscape phones, less than 768px) */\n  :root {\n    --font-xbig: 14px;\n    --font-big: 12px;\n    --font-medium: 11px;\n    --font-xmedium: 10px;\n    --font-small: 8px;\n    --font-xSmall: 6px;\n  }\n}\n\n@media (max-width: 991.98px) and (min-width: 767.98px) {\n  :root {\n    --font-xbig: 20px;\n    --font-big: 20px;\n    --font-medium: 13px;\n    --font-xmedium: 12px;\n    --font-small: 11px;\n    --font-xSmall: 8px;\n  }\n}\n\n@media (min-width: 991.98px) {\n  :root {\n    --font-xbig: 22px;\n    --font-big: 18px;\n    --font-medium: 14px;\n    --font-xmedium: 12px;\n    --font-small: 10px;\n    --font-xSmall: 8px;\n    --hide-on-sm: flex;\n  }\n}\n\ndiv.sticky {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 60px;\n  min-width: 100px;\n  min-height: 100px;\n}\n\n.hide-on-sm {\n  display: var(--hide-on-sm) !important;\n}\n\n.font-xbig {\n  font-size: var(--font-xbig) !important;\n}\n.font-big {\n  font-size: var(--font-big) !important ;\n}\n.font-medium {\n  font-size: var(--font-medium) !important;\n}\n.font-xmedium {\n  font-size: var(--font-xmedium) !important;\n}\n.font-small {\n  font-size: var(--font-small) !important;\n}\n.font-xSmall {\n  font-size: var(--font-xSmal) !important;\n}\n\n#root {\n  width: 100%;\n  height: 100vh;\n}\nh3 {\n  width: 100%;\n  text-align: center;\n}\n.width-100 {\n  width: 100% !important;\n}\n.width-95 {\n  width: 95% !important;\n}\n.width-90 {\n  width: 90% !important;\n}\n.width-80 {\n  width: 80% !important;\n}\n.width-75 {\n  width: 75% !important;\n}\n.width-70 {\n  width: 70% !important;\n}\n.width-60 {\n  width: 60% !important;\n}\n.width-50 {\n  width: 50% !important;\n}\n.width-30 {\n  width: 30% !important;\n}\n.width-40 {\n  width: 40% !important;\n}\n.width-45 {\n  width: 45% !important;\n}\n.width-33 {\n  width: 33.33% !important;\n}\n.width-25 {\n  width: 25% !important;\n}\n.width-20 {\n  width: 20% !important;\n}\n.width-10 {\n  width: 10% !important;\n}\n.width-30px {\n  width: 30px !important;\n}\n.width-auto {\n  width: auto !important;\n}\n.icon.XL {\n  height: 50px;\n}\n.inline-hor {\n  display: flex;\n  justify-content: space-between;\n}\nheader.large {\n  font-size: 20px;\n}\nheader.main {\n  margin-top: 20px;\n  padding-left: 10px !important;\n}\nheader {\n  font-weight: bold;\n  margin: 10px 0 15px 0;\n  width: 100%;\n  text-align: center;\n}\n.center-hor {\n  display: flex;\n  align-items: center;\n}\n.align-item-end {\n  display: flex;\n  align-items: end;\n}\n.center-ver {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n}\n.center-ver-col {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n}\n.absolute-center {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.space-evenly {\n  justify-content: space-evenly;\n}\n.space-around {\n  justify-content: space-around;\n}\n.space-between {\n  display: flex !important;\n  justify-content: space-between;\n}\n.align-bottom {\n  display: flex;\n  align-items: end;\n}\n.bold-1 {\n  font-weight: bold;\n}\n.bold-2 {\n  font-weight: heavy;\n}\n.table-head-bg {\n  /* background-color: rgba(102, 102, 102, 0.25) !important; */\n}\n.icon.mid {\n  height: 18px;\n}\n.icon.xmid {\n  height: 25px;\n}\n.icon.large {\n  height: 30px;\n}\n.icon.xlarge {\n  height: 60px;\n}\n.icon.color-lime {\n  color: rgb(75, 211, 75) !important;\n}\n.icon {\n  width: 100%;\n  cursor: pointer;\n}\n.golden {\n  color: var(--rf-brand-lite) !important;\n}\n.icon.white {\n  color: white;\n}\n.icon.grey.white {\n  color: white;\n}\n.icon.grey {\n  color: #6a6a6a;\n}\n.float-right-top {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n}\n.float-right-bottom {\n  position: absolute;\n  right: 0px;\n  bottom: 0;\n}\n.flex-start-ver {\n  display: flex;\n  align-items: flex-start;\n}\n.blur-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: 100vw;\n  filter: blur(3px);\n  z-index: 8;\n  background-color: rgba(255, 255, 255, 0.25);\n}\n.search.stretch {\n  width: 100% !important;\n}\n.margin-0 {\n  margin: 0px !important ;\n}\n.border-0 {\n  border: none !important;\n}\n.border-rad-0 {\n  border-radius: 0px !important;\n}\n.padding-LR-5 {\n  padding: 0 5px 0 5px !important;\n}\n.padding-LR-15 {\n  padding: 0 15px 0 15px !important;\n}\n.padding-10 {\n  padding: 10px !important;\n}\n.padding-5 {\n  padding: 5px !important;\n}\n.padding-0 {\n  padding: 0 !important;\n}\n.padding-bottom-200 {\n  padding-bottom: 200px !important;\n}\n.margin-top-5 {\n  margin-top: 5px;\n}\n.margin-top-10 {\n  margin-top: 10px !important;\n}\n.margin-top-50 {\n  margin-top: 50px;\n}\n.margin-top-20 {\n  margin-top: 20px !important;\n}\n.margin-top-100 {\n  margin-top: 100px !important;\n}\n.margin-TB-10 {\n  margin: 10px 0px !important;\n}\n.margin-10 {\n  margin: 10px !important;\n}\n.margin-5 {\n  margin: 5px !important;\n}\n.margin-LR-15 {\n  margin: 0 15px 0 15px !important;\n}\n.float-bottom {\n  position: absolute;\n  left: 0;\n  bottom: 10px;\n}\n.float-left {\n  position: absolute;\n  left: 10px;\n}\n.float-absolute-left {\n  position: absolute;\n  left: 0px;\n}\n.float-absolute-right {\n  position: absolute;\n  right: 0px;\n}\n.black-text {\n  color: black !important;\n}\n.red-text {\n  color: red !important;\n}\n.light-box-shadow {\n  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.25) !important;\n}\n.xlight-box-shadow {\n  box-shadow: 0px 3px 8px rgba(142, 139, 139, 0.1) !important;\n}\n.overlaid-page.success > * {\n  opacity: 0;\n}\n.overlaid-page {\n  min-width: 200px !important;\n  min-height: 100px !important;\n}\n.overlaid-page.active {\n  transition: 300ms;\n  opacity: 1;\n  top: 75px;\n  display: block;\n}\n.overlaid-page.add-user {\n  width: var(--slide);\n}\n.overlaid-page.summary {\n  min-height: 80vh !important;\n}\n.overlaid-page {\n  top: -100%;\n  opacity: 0;\n  display: none;\n  z-index: 0 !important;\n  position: absolute;\n  left: 3%;\n  width: 94%;\n  z-index: 99;\n  min-height: 80vh;\n  /* overflow-y: scroll; */\n  background-color: white;\n  transition: 300ms;\n}\n.float-bottom-right {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n}\n.float-bottom-left {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n}\n.gold-themed {\n  background-color: var(--rf-brand-lite) !important;\n  color: white !important;\n}\n.gold-themed-2 {\n  color: var(--rf-brand-lite) !important;\n  background-color: white !important;\n}\n.light-gold-themed {\n  background-color: #daba75 !important;\n  color: white !important;\n}\n.grey-themed {\n  background-color: #6a6a6a !important;\n  color: white !important;\n}\n.text-center {\n  text-align: center;\n}\n.icon-small {\n  height: 18px;\n}\n.float-right {\n  position: absolute;\n  right: 10px;\n}\n.float-left-bottom {\n  position: absolute;\n  left: 0;\n  bottom: 0;\n}\n.relative {\n  position: relative;\n}\n\n.small-list-card.user > img {\n  width: auto !important;\n  height: 40px !important;\n  position: absolute;\n  left: 5px;\n}\n.small-list-card.user:hover {\n  background-color: #faeac7;\n}\n.small-list-card.user {\n  position: relative;\n  height: 40px !important;\n  cursor: pointer;\n}\n.small-list-card.user > .icon {\n  position: absolute;\n  background-color: #d08484;\n  right: 0px;\n  top: 0px;\n}\n.small-list-card > .icon {\n  height: 40px;\n  padding: 10px 5px 10px 5px !important;\n  margin-right: 10px !important;\n  background-color: #d0b884;\n  cursor: pointer;\n}\n.small-list-card {\n  background-color: white;\n  height: 30px;\n  margin-bottom: 2px;\n}\n\n.display-none {\n  display: none;\n}\n.product-type-nav {\n  position: absolute;\n  top: 0;\n  width: 300px !important;\n  overflow-y: hidden;\n  z-index: 50;\n}\n\n.product-type-nav > div.toggleshower {\n  background: #eaeaea;\n  border-radius: 7px;\n  height: 25px;\n  cursor: pointer;\n  font-size: var(--font-small);\n  /* padding: 5px 10px; */\n  color: #6a6a6a;\n}\n.product-type-nav > div.dropdown-content {\n  display: none;\n  /* height: 0px; */\n  transition: 500ms;\n}\n.product-type-nav > div.dropdown-content.active {\n  /* position: absolute; */\n  background-color: white;\n  padding: 10px 4px;\n  /* display: block; */\n  /* height: 400px; */\n  display: flex;\n  transition: 500ms;\n}\n\n.product-type-nav > div > div {\n  cursor: pointer;\n  min-width: 70px;\n  padding: 0px 10px;\n  height: 25px;\n  border-radius: 6px;\n  color: #494949;\n  background-color: rgb(234, 234, 234);\n  font-weight: bold;\n  margin: 2px 0;\n}\n.product-type-nav > div:hover {\n  /* background-color: rgb(255, 255, 255); */\n}\n.product-type-select-card.active {\n  min-height: 100px;\n  transition: 500ms;\n  display: block;\n}\n.product-type-select-card {\n  min-height: 0px;\n  display: none;\n  transition: 500ms;\n}\n.typetags {\n  cursor: pointer;\n  min-width: 70px;\n  padding: 0px 10px;\n  height: 25px;\n  line-height: 25px;\n  text-align: center;\n  font-size: 11px;\n  border-radius: 6px;\n  color: #494949;\n  background-color: rgb(234, 234, 234);\n  font-weight: bold;\n  margin: 4px 5px;\n}\n.margin-TB-10 {\n  margin: 10px 0 10px 0;\n}\n.margin-TB-30 {\n  margin: 30px 0 30px 0;\n}\n.flex-start-bottom {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n}\n.relative-bottom {\n  position: absolute;\n  bottom: 10px;\n}\n.bg-red {\n  background-color: red !important;\n}\n.bg-grey {\n  background-color: rgb(165, 165, 165) !important;\n}\n.bg-white {\n  background-color: white !important;\n}\n.bg-lime {\n  background-color: lime !important;\n}\n.float-top-right-most {\n  position: absolute;\n  right: 0px;\n  top: 0px;\n}\n.float-top-right {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n}\n.float-right-most {\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n.stretch-height {\n  display: flex !important;\n  align-items: stretch !important;\n}\n.margin-left-10 {\n  margin: auto 10px !important;\n}\n.table-row > .x-small {\n  width: 40px !important;\n}\n.table-row > .small {\n  min-width: 50px !important;\n}\n.justify-end {\n  justify-content: flex-end !important;\n}\n.z-index-1 {\n  z-index: 1 !important;\n}\n.z-index-2 {\n  z-index: 2 !important;\n}\n.z-index-3 {\n  z-index: 3 !important;\n}\n.xsmall-btn {\n  height: 25px !important;\n}\n.small-btn {\n  height: 30px !important;\n}\n.touchable {\n  cursor: pointer;\n}\n.link-text {\n  color: var(--rf-brand-lite);\n}\n.link-text:hover {\n  color: #d0b884;\n}\n.hor-line {\n  border-top: 1px solid #d8d8d8;\n  width: 100%;\n  margin: 5px 0px;\n}\n.justify-center {\n  display: flex;\n  justify-content: center;\n}\n.green-themed {\n  background-color: #66b755;\n  color: white !important;\n}\n.hidden {\n  display: none !important;\n}\n.warning-text {\n  color: red;\n  font-size: var(--font-medium);\n  font-weight: bold;\n}\n.padding-TL-4-5 {\n  padding: 4px 5px;\n}\n.padding-TL-4-10 {\n  padding: 4px 10px;\n}\nbold {\n  font-weight: bold;\n}\n.warning-text {\n  color: red;\n}\n.flex-grow {\n  flex-grow: 1;\n}\n.display-flex {\n  display: flex;\n}\n.opacity-75 {\n  opacity: 0.75;\n}\n.profile-image-xlarge {\n  width: 100px !important;\n  height: 100px;\n  border-radius: 50%;\n}\n.light-gold {\n  background-color: #faeac7;\n}\n.light-red-bg {\n  background-color: #ffa1a1 !important;\n}\n.red-bg {\n  background-color: #b75555 !important;\n}\n.color-white {\n  color: white !important;\n}\n.color-gold {\n  color: #b79800 !important;\n}\n.margin-left-10 {\n  margin-left: 10px;\n}\n.paddingLR-10 {\n  padding-left: 30px;\n  padding-right: 30px;\n}\n.marginRight-2 {\n  margin-right: 1px;\n}\n.underline-1 {\n  border-bottom: 1px solid grey;\n}\n.color-black {\n  color: black !important;\n}\n.light-grey-bg {\n  background-color: #c9c9c9 !important;\n}\n.color-red {\n  color: red;\n}\n.height-stretch-container {\n  display: flex;\n  flex-wrap: wrap;\n  align-content: stretch;\n}\n.text-left {\n  text-align: left !important;\n}\n.text-right {\n  text-align: right !important;\n}\n.line-bottom-dashed {\n  border-bottom: 1px dashed black;\n}\n.margin-bottom-10 {\n  margin: 0px 0px 10px 0px !important;\n}\n.border-radius-8 {\n  border-radius: 8px !important;\n}\n.justify-start {\n  justify-content: start !important;\n}\n.justify-end {\n  justify-content: end !important;\n}\n.hover-underline:hover {\n  text-decoration: underline;\n}\n.text-list > span {\n  width: auto;\n  padding: 5px 10px;\n  font-weight: bold;\n}\n.border-none {\n  border: none !important;\n}\n.light-gold-header {\n  background: rgb(240, 212, 153);\n  color: white;\n}\n.light-grey-header {\n  background: rgb(244, 242, 242);\n  color: #c59800;\n}\n\n.flex-end {\n  justify-content: end;\n}\n.green-label-1{\n  background-color:#44bf44;\n  color: white;\n  font-weight: bold;\n  padding: 2px 10px;\n  border-radius: 10px;\n}\n.margin-right-5 {\n  margin-right: 5px !important;\n}\n.top-right {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n}\n.display-block {\n  display: block;\n}\n.red-label-1{\n  background-color: #dc4141;\n  color: white;\n  font-weight: bold;\n  padding: 2px 10px;\n  border-radius: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
